export default (window as any).Translator;
